import { useDynamicDataMutation } from '../../../../api/dynamicSites/hooks'
import useActivationObject from '../../../providers/ActivationObjectProvider/hooks/useActivationObject'
import { Step1Props, useStep1Props } from '../types'
import useStep1FileHandling from './useStep1.fileHandle'
import useStep1Form from './useStep1.form'
import useStep1FormConditions from './useStep1.form.conditions'
import useStep1FormOptions from './useStep1.form.options'
import { DynamicRequestBody } from '../../../../api/dynamicSites/types'
import { SiteAction } from '../../../../types'

const useStep1 = (props: useStep1Props): Step1Props => {
    const { data: activationObject, isUpdating } = useActivationObject()
    const formProps = useStep1Form(activationObject)
    const optionsProps = useStep1FormOptions(formProps.form)
    const conditionsProps = useStep1FormConditions(formProps.form, optionsProps)
    const useFileHandleProps = useStep1FileHandling(formProps.form)
    const dynamicMutation = useDynamicDataMutation()

    const handleDynamicAction = (siteType?: SiteAction) => {
        if (activationObject) {
            const dynamicBody = {
                synonym: activationObject.synonym,
                ...siteType,
            } as DynamicRequestBody

            dynamicMutation.mutate({ ...dynamicBody })
        }
    }

    const continueFullProtection = () => {
        handleDynamicAction(activationObject?.fullProtectionAction)
    }

    const helpProtection = () => {
        handleDynamicAction(activationObject?.helpProtectionAction)
    }

    const callMeProtection = () => {
        handleDynamicAction(activationObject?.callMeAction)
    }

    const buttonActions = {
        continueFullProtection,
        helpProtection,
        callMeProtection,
    }

    return {
        activationObject,
        form: formProps,
        file: useFileHandleProps,
        options: optionsProps,
        conditions: conditionsProps,
        buttonActions,
        isUpdating,
    }
}

export default useStep1
